import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { LoginService } from './login.service';
import { StorageService } from './storage.service';
import { NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  isLoggedIn!: boolean;
  currentUrl!: string;
  constructor(private storageService: StorageService, private loginService: LoginService, private route: Router) {
    this.route.events.subscribe((event) => {
      // if (event instanceof NavigationStart) {
      // Show progress spinner or progress bar
      // console.log('Route change detected');
      // }

      if (event instanceof NavigationEnd) {
        // Hide progress spinner or progress bar       
        // console.log('route',event.url);
        this.currentUrl = event.url;
      }

      // if (event instanceof NavigationError) {
      // Hide progress spinner or progress bar

      // Present error to user
      // console.log(event.error);
      // }
    });
  }

  isLoggedInUser(): any {
    const isLoggedIn = this.storageService.getSessionStorageData('isAuth');
    if (isLoggedIn) {
      return true;
    } else {
      return false;
    }
  }

  isRegistration(): any {
    if (this.currentUrl == '/registration') {
      return true;
    } else {
      return false;
    }
  }
}


